import React, { FC, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getHashParam } from '../../helpers/url/urlHelpers';
import IContentSectionTabs from '../../interfaces/umbracoNodes/contentSectionTabs';
import { ContentSectionsMapper } from '../../pages/contentSite/contentSectionsMapper';
import { Tab, Tabs } from '../base/tabs/tabs';
import { H3 } from '../base/typography';
import RegisterShipmentCalculator from '../registerShipmentCalculator';
import * as StyledTabs from './contentSectionTabs.styles';

interface Props {
	tabs: IContentSectionTabs[];
	useLinks?: boolean;
}

const ContentSectionTabs: FC<Props> = ({ tabs, useLinks }) => {
	const { t } = useTranslation('common');
	const queryTab = getHashParam('tab');
	const currentTab = parseInt(queryTab, 10) || 0;
	const [active, setActive]: [number, any] = useState(currentTab);
	const activeTab = tabs[active];
	const location = useLocation();

	const onTabClick = index => {
		setActive(index);
		if (useLinks) {
			window.history.pushState(null, null, `#tab=${index}`);
		}
	};

	return (
		<StyledTabs.Wrapper>
			<Tabs role="tablist">
				{tabs.map((tab, index) => (
					<Tab key={index} active={index === active} onClick={onTabClick.bind(null, index)} role="tab">
						{tab.Values.Title}
					</Tab>
				))}
			</Tabs>
			<AnimateHeight duration={400} height="auto" role="tabpanel">
				{['Pakkar til útlanda', 'International Parcels', 'Intl. parcels'].includes(activeTab.Values.Title) &&
				[
					'/einstaklingar/ymsar-upplysingar/verdskra/',
					'/en/individuals/information/rates/',
					'/fyrirtaeki/vorudreifing/verdskra/',
					'/en/business/distribution/rates/',
				].includes(location.pathname) ? (
					<StyledTabs.TabContentWrapper>
						<H3 marginTop="4rem" marginBottom="4rem">
							{t('calculator')}
						</H3>
						<RegisterShipmentCalculator country="GB" />
					</StyledTabs.TabContentWrapper>
				) : (
					activeTab.Values.Sections.map((section, index) => (
						<StyledTabs.TabContentWrapper key={index}>
							{ContentSectionsMapper(section)}
						</StyledTabs.TabContentWrapper>
					))
				)}
			</AnimateHeight>
		</StyledTabs.Wrapper>
	);
};

export default ContentSectionTabs;
